<template>
    <section>
        <div class="container">
            <div class="text-title">System Requirements</div>
            <system-requirements-table :sysReq="sysReq" :bordered="true" class="q-mb-md" />
        </div>
    </section>
</template>
<script>
    import systemRequirementsTable from '@/components/SystemRequirementsTable'
    export default {
        name: 'system-requirements',
        components: {
            systemRequirementsTable,
        },
        props: {
            sysReq: Object,
        },
        data() {
            return {

            }
        },
    }
</script>

